const RECENT_PAGES_KEY = "omnios-recent-pages";
const MAX_RECENT_PAGES = 8;

export interface RecentPage {
	to: string;
	label: string;
	ts: number;
}

function isRecord(value: unknown): value is Record<string, unknown> {
	return typeof value === "object" && value !== null;
}

function isRecentPage(value: unknown): value is RecentPage {
	return (
		isRecord(value) &&
		typeof value.to === "string" &&
		value.to.length > 0 &&
		typeof value.label === "string" &&
		value.label.length > 0 &&
		typeof value.ts === "number"
	);
}

export function readRecentPages(limit = 5): RecentPage[] {
	try {
		const raw = localStorage.getItem(RECENT_PAGES_KEY);
		if (!raw) return [];

		const parsed = JSON.parse(raw) as unknown;
		if (!Array.isArray(parsed) || !parsed.every(isRecentPage)) {
			localStorage.removeItem(RECENT_PAGES_KEY);
			return [];
		}

		return parsed.slice(0, limit);
	} catch {
		return [];
	}
}

export function rememberRecentPage(to: string, label?: string): RecentPage[] {
	const normalizedLabel = label?.trim() || to;
	const existing = readRecentPages(MAX_RECENT_PAGES);
	const next = existing.filter((page) => page.to !== to);
	next.unshift({
		to,
		label: normalizedLabel,
		ts: Date.now(),
	});

	localStorage.setItem(
		RECENT_PAGES_KEY,
		JSON.stringify(next.slice(0, MAX_RECENT_PAGES)),
	);

	return next;
}
